export * from './People1BossIcon';
export * from './People1BossIcon16Light';
export * from './People1BossIcon16Regular';
export * from './People1BossIcon16Solid';
export * from './People1BossIcon20Light';
export * from './People1BossIcon20Regular';
export * from './People1BossIcon20Solid';
export * from './People1BossIcon24Regular';
export * from './People1BossIcon24Solid';
export * from './People1BossIcon32Regular';
export * from './People1BossIcon64Regular';
